import { render, staticRenderFns } from "./MarketTrends.vue?vue&type=template&id=ebfb5948&scoped=true"
import script from "./MarketTrends.vue?vue&type=script&lang=js"
export * from "./MarketTrends.vue?vue&type=script&lang=js"
import style0 from "./MarketTrends.vue?vue&type=style&index=0&id=ebfb5948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfb5948",
  null
  
)

export default component.exports